import { render, staticRenderFns } from "./ListaMercancia.vue?vue&type=template&id=be8120da&"
import script from "./ListaMercancia.vue?vue&type=script&lang=js&"
export * from "./ListaMercancia.vue?vue&type=script&lang=js&"
import style0 from "./ListaMercancia.vue?vue&type=style&index=0&id=be8120da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports